import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ConsumptionMaterialWashingService } from 'services/consumption-material-washing-service';
import { ErrorService } from 'services/error-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class ConsumptionMaterialWashingNew {
  private consumptionMaterialWashing: Models.ConsumptionMaterialWashing = new Models.ConsumptionMaterialWashing();
  protected checkDuplicateData: Models.CheckDuplicateConsumptionMaterialWashing = new Models.CheckDuplicateConsumptionMaterialWashing();

  constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private consumptionMaterialWashingService: ConsumptionMaterialWashingService
  ) {}

  async createConsumptionMaterialWashing() {
    try {
      if (await this.checkDuplicate()) return;
      const consumptionMaterialWashing = await this.consumptionMaterialWashingService.post(this.consumptionMaterialWashing);
      this.eventAggregator.publish('consumableWashListReset', 1);
      this.toastService.showSuccess('consumptionMaterialWashing.created');
      this.router.navigateToRoute('service-consumption-material-washing-list');
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.ProductId = this.consumptionMaterialWashing.ProductId;
    const { IsDuplicate } = await this.consumptionMaterialWashingService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('consumptionMaterialWashingIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }
}
